<template>
  <div class="buy-sell-wrap">
    <div class="buy-sell-box">
      <header class="buy-header clear">
        <span class="left">{{ $t("buy_box.buy") }}{{ coinType_l }}</span>
        <span class="right"
          >{{ coinType_r }}&nbsp;{{ $t("buy_box.use") }}&nbsp;:&nbsp;{{
            getFloorNum(detail.money_total, detail.price_precision)
          }}</span
        >
      </header>
      <div class="input-box price-box">
        <label>{{ $t("buy_box.buy_price") }}</label>
        <span>
          <input
            autocomplete="off"
            maxlength="14"
            @input="buyPriceChange"
            type="number"
            :step="1 / Math.pow(10, detail.price_precision)"
            v-model="buyFormData.price"
            :disabled="!user.username"
          />
          <div class="unit">{{ coinType_r }}</div>
        </span>
      </div>
      <div class="cny-wrap">
        &#8776;&nbsp;{{ changeValueByRate(buyFormData.price) }} 
      </div>
      <div class="input-box amount-box">
        <label>{{ $t("buy_box.amount") }}</label>
        <span>
          <input
            autocomplete="off"
            maxlength="14"
            @input="buyAmountChange"
            type="number"
            :step="1 / Math.pow(10, detail.coin_precision)"
            v-model="buyFormData.amount"
            :disabled="!user.username"
			@focus="buyFormData.amount == 0 ? buyFormData.amount='' : buyFormData.amount"
			@blur="buyFormData.amount == '' ? buyFormData.amount=0 : buyFormData.amount"
          />
          <div class="unit">{{ coinType_l }}</div>
        </span>
      </div>
      <div class="slider-wrap">
        <el-slider
          class="buy-slider"
          :step="buy_step"
          :marks="buyMark"
          @change="buySliderAmountChange"
          v-model="buyFormData.sliderAmount"
          :max="buy_max"
          :disabled="detail.money_total === 0"
          :format-tooltip="buyFormatTooltip"
          v-show="user.username && parseFloat(buyFormData.price) > 0"
        ></el-slider>
        <div
          v-show="!user.username || !parseFloat(buyFormData.price) > 0"
          class="slider-disable"
        >
          <span class="p_25">25%</span>
          <span class="p_50">50%</span>
          <span class="p_75">75%</span>
        </div>
      </div>
      <div class="total-wrap">
        {{ $t("buy_box.money") }}
        <span v-if="user.username">
          <label>{{ getBuyTotalMoney }}</label
          >&nbsp;&nbsp;{{ coinType_r }}
        </span>
        <span v-else> <label>0</label>&nbsp;{{ coinType_r }} </span>
      </div>
      <div
        v-if="user.username"
        class="btn btn-buy"
        @click="checkTransPassword('buy')"
      >
        {{ $t("buy_box.buy") }}
      </div>
      <router-link to="/login" v-else>
        <div class="btn btn-buy">
          {{ $t("buy_box.loading") }}
        </div>
      </router-link>
    </div>
    <div class="buy-sell-box sell-box">
      <header class="sell-header clear">
        <span class="left">{{ $t("buy_box.sell") }}{{ coinType_l }}</span>
        <span class="right"
          >{{ coinType_l }}&nbsp;{{ $t("buy_box.use") }}&nbsp;:&nbsp;{{
            getFloorNum(detail.coin_total, detail.coin_precision)
          }}</span
        >
      </header>
      <div class="input-box price-box">
        <label>{{ $t("buy_box.sell_price") }}</label>
        <span>
          <input
            autocomplete="off"
            maxlength="14"
            @input="sellPriceChange"
            type="number"
            :step="1 / Math.pow(10, detail.price_precision)"
            v-model="sellFormData.price"
            :disabled="!user.username"
          />
          <div class="unit">{{ coinType_r }}</div>
        </span>
      </div>
      <div class="cny-wrap">
        &#8776;&nbsp;{{changeValueByRate(sellFormData.price) }}
      </div>
      <div class="input-box amount-box">
        <label>{{ $t("buy_box.amount") }}</label>
        <span>
          <input
            autocomplete="off"
            maxlength="14"
            @input="sellAmountChange"
            type="number"
            :step="1 / Math.pow(10, detail.coin_precision)"
            v-model="sellFormData.amount"
            :disabled="!user.username"
			@focus="sellFormData.amount == 0 ? sellFormData.amount='' : sellFormData.amount"
			@blur="sellFormData.amount == '' ? sellFormData.amount=0 : sellFormData.amount"
          />
          <div class="unit">{{ coinType_l }}</div>
        </span>
      </div>
      <div class="slider-wrap">
        <el-slider
          class="sell-slider"
          :step="sell_step"
          :marks="sellMark"
          @change="sellSliderAmountChange"
          v-model.number="sellFormData.sliderAmount"
          :max="detail.coin_total"
          :disabled="detail.coin_total === 0"
          :format-tooltip="sellFormatTooltip"
          v-show="user.username && parseFloat(sellFormData.price) > 0"
        >
        </el-slider>
        <div
          v-show="!user.username || !parseFloat(sellFormData.price) > 0"
          class="slider-disable"
        >
          <span class="p_25">25%</span>
          <span class="p_50">50%</span>
          <span class="p_75">75%</span>
        </div>
      </div>
      <div class="total-wrap">
        {{ $t("buy_box.money") }}
        <span v-if="user.username">
          <label>{{ getSellTotalMoney }}</label
          >&nbsp;&nbsp;{{ coinType_r }}
        </span>
        <span v-else> <label>0</label>&nbsp;{{ coinType_r }} </span>
      </div>
      <div
        v-if="user.username"
        class="btn btn-buy"
        @click="checkTransPassword('sell')"
      >
        {{ $t("buy_box.sell") }}
      </div>
      <router-link to="/login" v-else>
        <div class="btn btn-buy">
          {{ $t("buy_box.loading") }}
        </div>
      </router-link>
    </div>

    <div class="dialog-wrap" v-show="dialogFlag_buy">
      <div class="dialog-box">
        <h2>{{ $t("buy_box.trans_confirm") }}</h2>
        <ul>
          <li class="clear">
            <label>{{ $t("buy_box.buy_confirm") }}</label>
            <span class="right"
              >{{ getFloorNum(this.buyFormData.amount, detail.coin_precision) }}
              {{ this.buyFormData.symbol.split("/")[0] }}</span
            >
          </li>
          <li class="clear">
            <label>{{ $t("buy_box.trans_amount") }}</label>
            <span class="right"
              >{{ getBuyTotalMoney }}
              {{ this.buyFormData.symbol.split("/")[1] }}</span
            >
          </li>
          <li class="clear">
            <!-- 去除浏览器自动键入用户名和密码 -->
            <input style="position: fixed; bottom: -9999px" />
            <input type="password" style="position: fixed; bottom: -9999px" />
            <input
              v-model="buyFormData.password"
              :placeholder="$t('buy_box.trans_password_placeholder')"
              type="password"
            />
          </li>
        </ul>
        <div class="btn-wrap">
          <span
            class="btn btn-cancel"
            v-html="$t('buy_box.cancel')"
            @click="dialogFlag_buy = false"
          ></span>
          <span
            class="btn btn-confirm"
            v-html="$t('buy_box.confirm')"
            @click="trans('buy')"
          ></span>
        </div>
      </div>
    </div>
    <div class="dialog-wrap" v-show="dialogFlag_sell">
      <div class="dialog-box">
        <h2>{{ $t("buy_box.trans_confirm") }}</h2>
        <ul>
          <li class="clear">
            <label>{{ $t("buy_box.sell_confirm") }}</label>
            <span class="right"
              >{{ getFloorNum(this.sellFormData.amount, detail.coin_precision) }}
              {{ this.sellFormData.symbol.split("/")[0] }}</span
            >
          </li>
          <li class="clear">
            <label>{{ $t("buy_box.trans_amount") }}</label>
            <span class="right"
              >{{ getSellTotalMoney }}
              {{ this.sellFormData.symbol.split("/")[1] }}</span
            >
          </li>
          <li class="clear">
            <!-- 去除浏览器自动键入用户名和密码 -->
            <input style="position: fixed; bottom: -9999px" />
            <input type="password" style="position: fixed; bottom: -9999px" />
            <input
              v-model="sellFormData.password"
              :placeholder="$t('buy_box.trans_password_placeholder')"
              type="password"
            />
          </li>
        </ul>
        <div class="btn-wrap">
          <span
            class="btn btn-cancel"
            v-html="$t('buy_box.cancel')"
            @click="dialogFlag_sell = false"
          ></span>
          <span
            class="btn btn-confirm"
            v-html="$t('buy_box.confirm')"
            @click="trans('sell')"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import utils from "../../assets/js/utils";
import bus from "../../assets/js/bus";

export default {
  name: "v-buy-sell",
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          init_price: 0, //初始单价
          symbol: "RWA/USDT", //交易对
          money_total: 0.0, //可用资金
          coin_total: 0, //用户拥有的此币数量,
          price_precision: 4, //单价精度
          coin_precision: 4, //币的精度
          rate: 6, //汇率
        };
      },
    },
  },
  data() {
    return {
      dialogFlag_buy: false,
      dialogFlag_sell: false,
      hasSend: false, //交易是否已发送
      rate: 6,
      buyFormData: {
        direction: "buy",
        price: this.detail.init_price,
        symbol: this.detail.symbol,
        amount: 0,
        sliderAmount: 0, // 绑定滑动条的数量字段
        priceType: "limit",
        password: "",
        token: "",
      },
      buyMark: {},
      sellFormData: {
        direction: "sell",
        price: this.detail.init_price,
        symbol: this.detail.symbol,
        amount: 0,
        sliderAmount: 0, // 绑定滑动条的数量字段
        priceType: "limit",
        password: "",
        token: "",
      },
      sellMark: {},
      userAssets: {
        currency: null,
        totalAssetBTC: null,
        totalAssetCurrency: null,
        userAssetRsps: [],
      },
      buyPriceTimer: null,
      buyAmountTimer: null,
      sellPriceTimer: null,
      sellAmountTimer: null,
    };
  },
  created() {
    this.getBuyMarks();
    this.getSellMarks();
  },
  methods: {
	  changeValueByRate(price) {
		if(this.detail && this.detail.symbol) {
			if(this.detail.symbol.split("/")[1] === "USDT") {
				return this.getFloorNum(price * this.detail.rate, this.detail.price_precision) + " HKD"
			} else {
				return this.getFloorNum(price / this.detail.rate, this.detail.price_precision) + " USD"
			}
		}
	  },
    checkTransPassword(type) {
      if (this.user.orderConfirm > 0) {
        if (type === "buy") {
          if (
            parseFloat(this.buyFormData.price) <= 0 ||
            parseFloat(this.buyFormData.amount) <= 0
          ) {
            this.$message({
              type: "warning",
              message: this.$t("buy_box.input_error"),
            });
            return false;
          } else {
            this.dialogFlag_buy = true;
          }
        } else {
          if (
            parseFloat(this.sellFormData.price) <= 0 ||
            parseFloat(this.sellFormData.amount) <= 0
          ) {
            this.$message({
              type: "warning",
              message: this.$t("buy_box.input_error"),
            });
            return false;
          } else {
            this.dialogFlag_sell = true;
          }
        }
      } else {
        this.trans(type);
      }
    },
    trans(type) {
      if (this.hasSend) {
        return false;
      }
      let param = null;
      if (type === "buy") {
        param = this.buyFormData;
      } else {
        param = this.sellFormData;
      }
      this.$axios.post("/order/getTranToken", {}).then((res) => {
        param.token = res.data.data.token;
        this.$axios
          .post("/order/add", param)
          .then((res) => {
            this.hasSend = false; //放行交易开关
            if (res.data.code === this.errorCode.ok) {
              this.$message({
                type: "success",
                message: this.$t("buy_box.add_success"),
              });
              param.amount = param.sliderAmount = 0;
              this.dialogFlag_buy = false;
              this.dialogFlag_sell = false;
              bus.$emit("getUserAssets"); //更新用户资产
              setTimeout(function () {
                bus.$emit("getDelegation"); //更新委托订单(延迟1秒调用)
              }, 1000);
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.buyFormData.password = this.sellFormData.password = "";
          })
          .catch(() => {
            this.hasSend = false; //放行交易开关
            this.buyFormData.password = this.sellFormData.password = "";
          });
      });
    },
    buyFormatTooltip(value) {
      if (this.detail.money_total === 0) {
        return "0%";
      }
      return Math.floor((value / this.buy_max) * 100 * 100) / 100 + "%";
    },
    sellFormatTooltip(value) {
      if (this.detail.coin_total === 0) {
        return "0%";
      }
      return (
        Math.floor((value / this.detail.coin_total) * 100 * 100) / 100 + "%"
      );
    },
    buyPriceChange() {
      let that = this;
      clearTimeout(that.buyPriceTimer);
      that.buyPriceTimer = setTimeout(function () {
        if (that.buyFormData.price.toString().indexOf(".") >= 0) {
          let reg = /[1-9]/;
          if (!reg.test(that.buyFormData.price.toString().split(".")[1])) {
            return false;
          }
        }
        if (that.buyFormData.price === "") {
          that.buyFormData.price = 0;
        } else {
          that.buyFormData.price = that.getFloorNum(
            that.buyFormData.price,
            that.detail.price_precision,
          );
        }
      }, 1000);
    },
    buyAmountChange() {
      if (this.buyFormData.amount === "") {
        this.buyFormData.sliderAmount = 0;
        return;
      }
      if (parseFloat(this.buyFormData.price) > 0) {
        let maxBuyAmount = this.detail.money_total / this.buyFormData.price;
        if (Number(this.buyFormData.amount) > maxBuyAmount) {
          this.buyFormData.amount = this.buyFormData.sliderAmount = maxBuyAmount;
          return;
        }
      }
      this.buyFormData.sliderAmount = Number(this.buyFormData.amount);
      let that = this;
      clearTimeout(that.buyAmountTimer);
      that.buyAmountTimer = setTimeout(function () {
        if (that.buyFormData.amount.toString().indexOf(".") >= 0) {
          let reg = /[1-9]/;
          if (!reg.test(that.buyFormData.amount.toString().split(".")[1])) {
            return false;
          }
        }
        if (that.buyFormData.amount === "") {
          that.buyFormData.sliderAmount = that.buyFormData.amount = 0;
        } else {
          that.buyFormData.sliderAmount = that.buyFormData.amount =
            that.getFloorNum(
              that.buyFormData.amount,
              that.detail.coin_precision,
            );
        }
      }, 1000);
    },
    buySliderAmountChange() {
      this.buyFormData.amount = this.getFloorNum(this.buyFormData.sliderAmount, this.detail.coin_precision);
      console.log(this.buyFormData.amount)
    },
    sellPriceChange() {
      let that = this;
      clearTimeout(that.sellPriceTimer);
      that.sellPriceTimer = setTimeout(function () {
        if (that.sellFormData.price.toString().indexOf(".") >= 0) {
          let reg = /[1-9]/;
          if (!reg.test(that.sellFormData.price.toString().split(".")[1])) {
            return false;
          }
        }
        if (that.sellFormData.price === "") {
          that.sellFormData.price = 0;
        } else {
          that.sellFormData.price = that.getFloorNum(
            that.sellFormData.price,
            that.detail.price_precision,
          );
        }
      }, 1000);
    },
    sellAmountChange() {
      if (this.sellFormData.amount === "") {
        this.sellFormData.sliderAmount = 0;
        return;
      }
      if (Number(this.sellFormData.amount) > this.detail.coin_total) {
        this.sellFormData.amount = this.sellFormData.sliderAmount =
          this.detail.coin_total;
        return;
      }
      this.sellFormData.sliderAmount = Number(this.sellFormData.amount);
      let that = this;
      clearTimeout(that.sellAmountTimer);
      that.sellAmountTimer = setTimeout(function () {
        if (that.sellFormData.amount.toString().indexOf(".") >= 0) {
          let reg = /[1-9]/;
          if (!reg.test(that.sellFormData.amount.toString().split(".")[1])) {
            return false;
          }
        }
        if (that.sellFormData.amount === "") {
          that.sellFormData.sliderAmount = that.sellFormData.amount = 0;
        } else {
          that.sellFormData.sliderAmount = that.sellFormData.amount =
            that.getFloorNum(
              that.sellFormData.amount,
              that.detail.coin_precision,
            );
        }
      }, 1000);
    },
    sellSliderAmountChange() {
      this.sellFormData.amount = this.getFloorNum(this.sellFormData.sliderAmount, this.detail.coin_precision);
      console.log(this.sellFormData.amount)
    },
    //买入进度条分段设定
    getBuyMarks() {
      if (this.detail.money_total === 0 || this.detail.money_total === "") {
        return false;
      }
      this.buyMark = {};
      // 保留特殊比例标记点：0%, 25%, 50%, 75%, 100%
      this.$set(this.buyMark, 0, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "0%"),
      });
      this.$set(this.buyMark, this.buy_max * 0.25, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "25%"),
      });
      this.$set(this.buyMark, this.buy_max * 0.5, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "50%"),
      });
      this.$set(this.buyMark, this.buy_max * 0.75, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "75%"),
      });
      this.$set(this.buyMark, this.buy_max, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "100%"),
      });
    },
    //卖出进度条分段设定
    getSellMarks() {
      if (this.detail.coin_total === 0 || this.detail.coin_total === "") {
        return false;
      }
      this.sellMark = {};
      // 保留特殊比例标记点：0%, 25%, 50%, 75%, 100%
      this.$set(this.sellMark, 0, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "0%"),
      });
      this.$set(this.sellMark, this.detail.coin_total * 0.25, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "25%"),
      });
      this.$set(this.sellMark, this.detail.coin_total * 0.5, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "50%"),
      });
      this.$set(this.sellMark, this.detail.coin_total * 0.75, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "75%"),
      });
      this.$set(this.sellMark, this.detail.coin_total, {
        style: {
          color: "#ffffff",
          fontSize: "12px",
        },
        label: this.$createElement("strong", "100%"),
      });
    },
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
    coinType_l() {
      return this.detail.symbol.split("/")[0];
    },
    coinType_r() {
      return this.detail.symbol.split("/")[1].replace("T","");
    },
    buy_max() {
      if (!this.user.username || !window.localStorage.getItem("jwt-token")) {
        return 0;
      }
      return this.detail.money_total / this.buyFormData.price;
    },
    buy_step() {
      // 使用更小的步长支持任意比例滑动，同时保留25%间隔的标记点
      let step = this.buy_max / 100; // 将滑动条分为100份，支持1%精度的滑动
      return step;
    },
    sell_step() {
      // 使用更小的步长支持任意比例滑动，同时保留25%间隔的标记点
      let step = this.detail.coin_total / 100; // 将滑动条分为100份，支持1%精度的滑动
      return step;
    },
    getBuyTotalMoney() {
      return (this.buyFormData.price * this.buyFormData.amount).toFixed(
        this.detail.price_precision,
      );
    },
    getSellTotalMoney() {
      return (this.sellFormData.price * this.sellFormData.amount).toFixed(
        this.detail.price_precision,
      );
    },
  },
  watch: {
    "buyFormData.price": function () {
      this.getBuyMarks();
    },
    "buyFormData.sliderAmount": function () {
      this.buyFormData.amount = this.buyFormData.sliderAmount;
    },
    "detail.init_price": function () {
      this.buyFormData.price = this.sellFormData.price = this.detail.init_price;
      this.buyFormData.amount =
        this.sellFormData.amount =
        this.buyFormData.sliderAmount =
        this.sellFormData.sliderAmount =
          0;
    },
    "detail.symbol": function () {
      this.buyFormData.symbol = this.sellFormData.symbol = this.detail.symbol;
    },
    "detail.money_total": function () {
      this.getBuyMarks();
    },
    "detail.coin_total": function () {
      this.getSellMarks();
    },
  },
};
</script>

<style lang="less" scoped>
.buy-sell-wrap {
  display: flex;
  width: 100%;
}

.buy-sell-box {
  flex: 1;
  color: #333333;
  .buy-header {
    margin-bottom: 10px;
    color: #333;
    .left {
      color: #52c18e;
    }
  }
  .sell-header {
    margin-bottom: 10px;
    color: #333;
    .left {
      color: #f04545;
    }
  }
  .input-box {
    display: flex;
    label {
      min-width: 24px;
      line-height: 40px;
      margin-right: 10px;
    }
    span {
      flex: 1;
      position: relative;
    }
    input {
      position: static;
      width: 100%;
      background: rgba(234, 235, 237, 0.5);
      border-radius: 6px 6px 6px 6px;
      text-indent: 8px;
      height: 40px;
      line-height: 1;
      padding: 9px 0 11px;
      box-sizing: border-box;
      font-size: 16px;
    }
    .unit {
      position: absolute;
      top: 50%;
      right: 6px;
      transform: translateY(-50%);
      color: #333333;
    }
  }
  .price-box {
    margin-bottom: 4px;
  }
  .cny-wrap {
    margin-bottom: 8px;
    text-indent: 35px;
    font-size: 12px;
    color: #333333;
  }
  .slider-wrap {
    margin: 5px 0 10px;
    .slider-disable {
      margin: 14px 0 20px;
      position: relative;
      width: 100%;
      height: 17px;
      line-height: 17px;
      // background: #262b3f;
      color: #a0aac1;
      font-size: 12px;
      span {
        display: inline-block;
        position: absolute;
      }
      .p_25 {
        top: 50%;
        left: 25%;
        transform: translate(-50%, -50%);
      }
      .p_50 {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .p_75 {
        top: 50%;
        left: 75%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .total-wrap {
    span {
      label {
        font-size: 16px;
      }
      margin-left: 10px;
      color: #333;
    }
  }
  .btn {
    margin-top: 10px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 12px;
    background: #3ec197;
    font-size: 16px;
    font-weight: bold;
    color: white;
    border: 1px solid transparent;
    cursor: pointer;
    user-select: none;
    &:hover {
      border-color: rgba(255, 255, 255, 0.8);
    }
    &:active {
      box-shadow: 2px 2px 5px rgba(255, 255, 255, 0.5);
    }
  }
}

.sell-box {
  margin-left: 80px;
  .btn {
    background: #f04c66;
  }
}

.dialog-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1002;
  .dialog-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 350px;
    padding: 30px 44px;
    background: white;
    border-radius: 20px;
    text-align: center;
    h2 {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      font-size: 16px;
      color: #a0aac1;
      margin-top: 30px;
      label {
        color: #42cb83;
      }
    }
    .input-wrap {
      margin-top: 20px;
    }
    .clear {
      border-bottom: 1px solid #d8d8d8;
      padding: 10px 0;
      text-align: left;
      label {
        color: #a0aac1;
      }
      input {
        width: 100%;
        outline: none;
        &::placeholder {
          color: #a0aac1;
        }
      }
    }
    .btn-wrap {
      margin-top: 30px;
      display: flex;
      gap: 40px;
      justify-content: space-between;
      .btn {
        display: inline-block;
        width: 136px;
        height: 40px;
        line-height: 40px;
        border-radius: 2px;
        cursor: pointer;
        user-select: none;
      }
      .btn-cancel {
        color: var(--primary-color);
        background: #FFF;
        border: 1px solid var(--primary-color);
      }
      .btn-confirm {
        background: var(--primary-color);
        color: white;
      }
    }
  }
}
input:focus {
  outline: none;
}
</style>
